<template>
  <b-container class="post-main-container" v-if="post.customer_details" fluid>
    <b-row no-gutters class="user-info-row">
      <b-col cols="2" sm="1" class="post-img-holder">
        <div class="post-user-img">
          <b-img :src="post.customer_details.prof_pic"></b-img>
        </div>
      </b-col>
      <b-col cols="9" sm="10" class="post-user-info">
        <div class="user-info">
          <router-link
            :to="{
              name: 'MemberWall',
              params: { customerId: post.customer_details.customer_id },
            }"
          >
            <p class="post-username m-0">{{ post.customer_details.name }}</p>
          </router-link>
          <p class="post-user-position m-0">
            {{ post.customer_details.job_title }}
            @
            <router-link
              :to="{
                name: 'companyProfile',
                params: { companyId: post.customer_details.company_id },
              }"
            >
              <span class="post-company-name">
                {{ post.customer_details.company }}
              </span>
            </router-link>
          </p>
          <p class="post-created-time m-0">
            {{ moment(post.created, "YYYYMMDD").fromNow() }}
          </p>
        </div>
      </b-col>
      <b-col cols="1" sm="1">
        <div id="dropdown-section">
          <button class="dropdownLink" @click="dropIt">
            <i class="fa fa-circle" aria-hidden="true"></i>
            <i class="fa fa-circle" aria-hidden="true"></i>
            <i class="fa fa-circle" aria-hidden="true"></i>
          </button>
          <transition name="slide">
            <ul class="list" v-if="isDropped">
              <li class="listItem" @click="handleCopyLink(post)">
                <i class="fas fa-link"></i> Copy post link
              </li>
              <li class="listItem"  v-if="isUserPost" @click="isOpenEditPost = !isOpenEditPost;">
                <i class="fa fa-pencil"></i> Edit Post
              </li>
              <li
                class="listItem"
                 v-if="isUserPost "
                @click="isOpenDeleteModal = !isOpenDeleteModal"
              >
                <i class="fa fa-trash"></i> Delete Post
              </li>
              <li
               @click="unfollowUser"
                class="listItem"
                 v-if="!isUserPost && !fromSearch && !hideUnfollow"
              >
                <i class="fas fa-eye-slash"></i> Unfollow {{post.customer_details.name}}
              </li>
              <li
                class="listItem"
                @click="$refs.reportModals.$refs['report-modal'].show()"
                 v-if="!isUserPost && !fromSearch"
              >
               <i class="fas fa-flag"></i> Report this post
              </li>
            </ul>
          </transition>
        </div>
      </b-col>
    </b-row>
    <b-row no-gutters class="add-border">
      <b-col>
         <p class="post-content">  <read-more more-str="read more" :text="getPostContent()" link="#" less-str="read less" :max-chars="300"></read-more></p>

        <div
          v-if="post.media.length && video"
          class="user-video-upload"
        >
        <video-embed :src="video" v-if="getHostName(video)"></video-embed>
        <a :href="video" v-else class="video-link" target="_blank">{{video.substr(0,50)}}...</a>

        </div>
        <postImageCollage
          v-if="imagesLength"
          :columns="getCollageSettings()"
          :images="images"
        />
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <PostActions :post="post" :isUserPost="isUserPost" :fromSearch="fromSearch" /> </b-col
    ></b-row>
    <b-modal v-model="isOpenEditPost" title="Edit Post" hide-footer >
     <PostEdit
     :post="post"
     @postUpdated="postUpdated"/>
    </b-modal>
    <b-modal v-model="isOpenDeleteModal" title="Delete Post" hide-footer>
      <b-container fluid class="p-0">
        <b-row
          style="
            border-top: 4px solid #ebebeb;
            border-bottom: 4px solid #ebebeb;
          "
        >
          <p class="warning-text">Are you sure you want to delete this post?</p>
        </b-row>
        <b-row class="justify-content-end">
          <b-button @click="removePost" size="sm" class="ok-btn">YES</b-button>
          <b-button
            @click="isOpenDeleteModal = !isOpenDeleteModal"
            size="sm"
            class="cancel-btn"
            >CANCEL</b-button
          >
        </b-row>
      </b-container>
    </b-modal>
    <ReportModals @reportSuccess="onReportSuccess" ref="reportModals" :post="post" />
  </b-container>
</template>

<script>
import { mapGetters } from 'vuex';
import moment from 'moment';
import postImageCollage from './postImageCollage.vue';
import PostActions from './PostActions.vue';
import PostEdit from '../posts/PostEdit.vue';
import ReportModals from './ReportModals.vue';

export default {
  props: {
    postData: {
      type: Object,
      default: () => ({}),
    },
    companyDetails: {
      type: Object,
      default: () => ({}),
    },
    isUserPost: {
      type: Boolean,
      default: false,
    },
    fromSearch: {
      type: Boolean,
      default: false,
    },
    hideUnfollow: {
      type: Boolean,
      default: false,
    },
  },
  name: 'Post',
  components: {
    PostActions,
    postImageCollage,
    PostEdit,
    ReportModals
  },
  data() {
    return {
      index: null,
      comments: [],
      images: [],
      video: null,
      imagesLength: 0,
      isDropped: false,
      isOpenEditPost: false,
      isOpenDeleteModal: false,
      post: {
        media: [],
        content: '',
        id: null,
      },
    };
  },
  computed: {
    ...mapGetters({
      userInfo: 'user/fetchUserInfo',
    }),
  },
  methods: {
    async removePost() {
      this.$emit('deleteWallPost', this.post.id);
      this.dropIt();
      this.isOpenDeleteModal = !this.isOpenDeleteModal;
    },
    postUpdated(type) {
      this.isOpenEditPost = !this.isOpenEditPost;
      this.dropIt();
      if (type === 'success') {
        this.$notify({
          group: 'userAlerts',
          title: 'Success',
          text: 'The post successfully updated!',
          type: 'success',
        });
      } else if (type === 'warning') {
        this.$notify({
          group: 'userAlerts',
          title: 'Warning',
          text: 'Please add something to post!',
          type: 'warn',
        });
      } else {
        this.$notify({
          group: 'userAlerts',
          title: 'Error',
          text: 'Something went wrong!',
          type: 'error',
        });
      }
    },
    handleCopyLink(post) {
      if (this.$lodash.get(navigator, 'clipboard.writeText', false)) {
        navigator.clipboard.writeText(
          `${process.env.VUE_APP_CLIENT_URL}/personal-wall/post/${post.id}`,
        );
        this.$notify({
          group: 'userAlerts',
          title: 'Success',
          text: 'The link to post successfully copied!',
          type: 'success',
        });
      } else {
        this.$notify({
          group: 'userAlerts',
          title: 'Error',
          text: 'The post successfully deleted!',
          type: 'error',
        });
      }
    },
    dropIt() {
      this.isDropped = !this.isDropped;
    },
    getHostName(url) {
      let videoType = '';
      const regexYoutube = new RegExp(/(?:https?:\/\/)?(?:www\.)?youtu\.?be(?:\.com)?\/?.*(?:watch|embed)?(?:.*v=|v\/|\/)([\w\-_]+)&?/);
      const regexVimeo = new RegExp(/(?:http|https)?:?\/?\/?(?:www\.)?(?:player\.)?vimeo\.com\/(?:channels\/(?:\w+\/)?|groups\/(?:\/]*)\/videos\/|video\/|)(\d+)(?:|\/\?)/);
      const isYoutubeUrl = regexYoutube.test(url);
      const isVimeoUrl = regexVimeo.test(url);
      if (isYoutubeUrl) videoType = 'youtube';
      if (isVimeoUrl) videoType = 'vimeo';
      return videoType;
    },
    moment(date) {
      return moment(new Date(date));
    },
    getCollageSettings() {
      const { imagesLength, images } = this;
      const columns = [];
      const rows = [
        {
          columns: [],
        },
        {
          columns: [],
        },
      ];
      if (imagesLength) {
        switch (imagesLength) {
          case 1:
            columns.push(...images);
            break;
          case 2:
            columns.push(...images);
            break;
          case 3:
            columns.push(images[0]);
            rows[0].columns.push(images[1]);
            rows[1].columns.push(images[2]);
            columns.push({ rows });
            break;
          case 4:
            columns.push(images[0]);
            rows[0].columns.push(images[1], images[2]);
            rows[1].columns.push(images[3]);
            columns.push({ rows });
            break;
          default:
            columns.push(images[0]);
            rows[0].columns.push(images[1], images[2]);
            rows[1].columns.push(images[3], images[4]);
            columns.push({ rows });
        }
      }
      return columns;
    },
    getPostContent() {
      let postDescription = this.post.content;
      const words = this.post.content ? postDescription.split(' ') : [];
      words.forEach((word, i, arr) => {
        if (word.startsWith('#')) {
          // eslint-disable-next-line no-param-reassign
          arr[i] = `<span style='color: #055FDF;'>${word}</span>`;
        }
      });
      postDescription = words.join(' ');

      postDescription = postDescription
        && postDescription.replace(
          /(http|www)(\S*)/g,
          "<a href=\"$1$2\" style='color: #BD9D5F; text-decoration: underline; cursor: pointer;' target='_blank'>$1$2</a>",
        );
      if (
        Array.isArray(this.post.tagged_customers)
        && this.post.tagged_customers.length > 0
      ) {
        this.post.tagged_customers.forEach(({ full_name, customer_id }) => {
          postDescription = postDescription.replace(
            full_name,
            `<a href="/personal-wall/${customer_id}"><span style='color: #BD9D5F;'>${full_name}</span></a>`,
          );
        });
      }
      return postDescription;
    },
    unfollowUser() {
      this.$emit('unfollowUser', {
        customerId: this.post.customer_details.customer_id,
        sharedPost: false
      });
    },
    onReportSuccess({ postUrl, reason }) {
      this.$emit('reportSuccess', { postUrl, reason });
    },
  },
  watch: {
    postData: {
      immediate: true,
      deep: true,
      handler(post) {
        this.post = { ...post };
        if (post.media.length) {
          if (post.media[0].media_type === 'video') {
            this.video = post.media[0].video_field;
          }
          if (post.media[0].media_type === 'image') {
            this.images = post.media.map((img, index) => ({
              image: img.image_field,
              id: index,
            }));
            this.imagesLength = this.images.length;
          }
        }
      },
    },
  },
};
</script>
<style scoped src="./css/Post.css"></style>
<style scoped>
.post-main-container {
  background: white;
  margin-bottom: 15px;
  border-radius: 0 10px 10px 10px;
  padding: 0;
}
.post-trash {
  color: #bd9d5f;
  background: white;
  margin: 10px;
  cursor: pointer;
}

</style>
<style>
#readmore{
  color: #bd9d5f;
  font-weight: bold;
}
</style>
